module.exports = __webpack_public_path__ + "static/media/operation-green.5a1f5237.svg";